import axios from 'axios';
import { Device, DeviceListResponse, Message } from '../types';

const API_BASE_URL = process.env.REACT_APP_API_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

export const deviceService = {
  // Get all devices with pagination and filtering
  async getDevices(params?: {
    page?: number;
    limit?: number;
    search?: string;
    status?: string;
  }): Promise<DeviceListResponse> {
    const response = await api.get('/devices', { params });
    return response.data;
  },

  // Get a specific device by ID
  async getDevice(id: string): Promise<Device> {
    const response = await api.get(`/devices/${id}`);
    return response.data;
  },

  // Get latest messages for a device
  async getDeviceMessages(deviceId: string, limit: number = 10): Promise<Message[]> {
    const response = await api.get(`/devices/${deviceId}/messages`, {
      params: { limit }
    });
    return response.data;
  },

  // Update a device name
  async updateDevice(id: string, name: string): Promise<any> {
    const response = await api.put(`/devices/${id}`, { name });
    return response.data;
  },

  // Get latest data for a device
  async getLatestData(deviceId: string): Promise<any> {
    const response = await api.get(`/devices/${deviceId}/latest`);
    return response.data;
  },

  // Get device status (derived from latest message timestamp)
  getDeviceStatus(lastMessageAt?: string): 'online' | 'offline' | 'warning' {
    if (!lastMessageAt) return 'offline';

    const lastMessage = new Date(lastMessageAt);
    const now = new Date();
    const diffInMinutes = (now.getTime() - lastMessage.getTime()) / (1000 * 60);

    if (diffInMinutes < 60) return 'online';        // Less than 1 hour
    if (diffInMinutes < 480) return 'warning';      // Less than 8 hours
    return 'offline';                               // More than 8 hours
  }
};

export default deviceService;
